var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    style: {
      marginRight: 4
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#check_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    x: 8,
    y: 6,
    fill: "#51C394",
    rx: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22 25.833a5.833 5.833 0 1 1 0-11.666 5.833 5.833 0 0 1 0 11.666ZM14.5 20a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Zm11.117-1.06a.846.846 0 0 0 .016-1.188.833.833 0 0 0-1.178-.016l-3.697 3.594-1.502-1.503a.833.833 0 0 0-1.179 1.179l2.084 2.083a.833.833 0 0 0 1.17.009l4.286-4.167Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "check_svg__a",
    width: 37,
    height: 37,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_832_69650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_832_69650",
    result: "shape"
  })))));
};
export default SvgCheck;